import { Trans } from 'react-i18next';
import ModeStandbyIcon from '@mui/icons-material/ModeStandby';
import CancelIcon from '@mui/icons-material/Cancel';
import { NotificationPresenter } from '@notifications/interfaces';
import { NotificationMessageBlock } from '@notifications/components/NotificationMessageBlock';
import { ShootingClearanceRevokedNotificationData } from './interfaces';
import { ShootingClearanceCategory } from '@api/shootingApi/interfaces';
import { clearanceCategoryLabel } from '@helpers/clearanceCategories';
import i18n from '@translations/i18n';

const isShootingClearanceRevokedPayload = (
  payload: unknown
): payload is ShootingClearanceRevokedNotificationData => {
  if (typeof payload !== 'object' || payload === null) {
    return false;
  }

  return (
    'clearanceCategory' in payload &&
    typeof payload.clearanceCategory === 'string'
  );
};

const categoryLabel = (category: string): string =>
  clearanceCategoryLabel(category as ShootingClearanceCategory, i18n.t);

const revokeReasonText = (revokeNotes?: string | null): string | null => {
  if (typeof revokeNotes !== 'string') {
    return null;
  }

  const trimmed = revokeNotes.trim();

  return trimmed.length > 0 ? trimmed : null;
};

export const shootingClearanceRevokedPresenter: NotificationPresenter<ShootingClearanceRevokedNotificationData> =
  {
    type: 'shooting-clearance-revoked',
    icon: ModeStandbyIcon,
    badgeIcon: CancelIcon,
    isPayload: isShootingClearanceRevokedPayload,
    label: (payload, t) =>
      t('notifications:types.shooting-clearance-revoked', {
        category: categoryLabel(payload.clearanceCategory),
      }),
    message: (payload) => (
      <Trans
        i18nKey="notifications:menu.shooting-clearance-revoked"
        values={{
          category: categoryLabel(payload.clearanceCategory),
        }}
        components={{
          bold: <strong />,
        }}
      />
    ),
    body: (payload) => {
      const reason = revokeReasonText(payload.revokeNotes);

      if (!reason) {
        return null;
      }

      return <NotificationMessageBlock>{reason}</NotificationMessageBlock>;
    },
    path: () => '/profile',
  };
